import type { ReactNode } from "react";

type PanelProps = {
  children: ReactNode;
  className?: string;
  "aria-live"?: "off" | "polite" | "assertive";
};

export function Panel({ children, className = "", ...rest }: PanelProps) {
  return <section className={`panel ${className}`.trim()} {...rest}>{children}</section>;
}
